import styled from 'styled-components';
import { Button } from 'antd';

export const StyledButton = styled(Button)`
  background-color: rgb(219, 1, 28);
  color: rgb(255, 255, 255);
`;
